export default __webpack_public_path__ + "static/media/04C.020.7906181f.png";